// Module
var code = "<!-- ko if: HasTimer --> <!-- ko with: _timerControl --> <!-- ko template: { name: GetLiveTimerForKanbanTemplateName.bind($data), afterRender: $data.AfterRender.bind($data) } --><!-- /ko --> <!-- /ko --> <!-- /ko -->";
// Exports
export default code;